(function ($) {
  $(document).ready(function () {
    $("#clinic-suggestions").hide();

    /* Get param bereich and lead user to the desired tab */
    var bereich = $.getUrlVar("bereich");
    if (bereich) {
      if (bereich === "tab-1") {
        $(
          '.gridelement-clinics_and_centers_az .tabs-nav .nav a[href="#tab-1"]'
        ).trigger("click");
      } else if (bereich === "zentren") {
        $(
          '.gridelement-clinics_and_centers_az .tabs-nav .nav a[href="#tab-2"]'
        ).trigger("click");
      } else if (bereich === "belegabteilungen") {
        $(
          '.gridelement-clinics_and_centers_az .tabs-nav .nav a[href="#tab-3"]'
        ).trigger("click");
      }
    }

    $(
      '.gridelement-clinics_and_centers_az .tabs-nav .nav a[href="#tab-1"], .gridelement-clinics_and_centers_az .tabs-nav .nav a[href="#tab-2"], .gridelement-clinics_and_centers_az .tabs-nav .nav a[href="#tab-3"]'
    ).on("click", function () {
      resetDeepening();
      performSearch($inputField.val());
      reset();
    });

    var openPanels = function () {
      $(".list-with-arrow ul > li > span")
        .parent()
        .addClass("active")
        .find("ul")
        .slideDown(300);
    };

    openPanels();

    /* Reset everything and get keywords that can be found within a tab content */
    $(".gridelement-clinics_and_centers_az .tabs-nav .nav a").on(
      "shown.bs.tab",
      function (e) {
        // Set current tab id to only focus on items within a single tab
        currentTabId = $(e.target).attr("href").substr(1);
        // Reset the view
        reset();
        // Get the keywords of all items within the current tab
        getKeywords();

        openPanels();
      }
    );

    /* Define the needed variables */
    var $inputField = $(
      '.gridelement-clinics_and_centers_az input[type="text"]'
    );
    $searchButton = $(
      ".gridelement-clinics_and_centers_az .f-filter button[type=submit]"
    );
    $suggestions = $("#clinic-suggestions");
    currentDeepening = 0;
    currentTabId = "tab-1";
    optionPrepended = false;
    globalKeywords = [];

    /* Input-Field listening */
    $inputField
      .on("focus", function (event) {
        searchForKeyword(event);
      })
      .on("keyup", function (event) {
        searchForKeyword(event);
      });

    $searchButton.on("click", function (event) {
      event.preventDefault();
      var input = $inputField.val().toLowerCase();
      if (input) {
        performSearch(input, false);
      }
    });

    /**
     * Get all keywords for parents and child
     * Merge those into a sorted array
     */
    var getKeywords = function () {
      globalKeywords = [];
      $(
        "#" +
          currentTabId +
          " .c-parent > li > span, #" +
          currentTabId +
          " .c-childs > li"
      ).each(function (index) {
        if ($(this).data("keywords")) {
          var items = $(this).data("keywords").split(",");
          if (items) {
            $.each(items, function (key, keyword) {
              keyword = keyword.trim();
              if (keyword && globalKeywords.indexOf(keyword) === -1) {
                globalKeywords.push(keyword);
              }
            });
          }
        }
        // Also take link titles as keywords
        if (
          $(this).text() &&
          $(this).text().trim() &&
          !inArray($(this).text().trim(), globalKeywords)
        ) {
          globalKeywords.push($(this).text().trim());
        }
      });
      // Sort globalKeywords alphabetically
      globalKeywords.sort(compareStrings);
    };

    // Get keywords for the first time
    getKeywords();

    /* Look up for keywords that match the user's input */
    var searchForKeyword = function (event) {
      if (event.key == "Enter") {
        if ($inputField.val().trim) {
          resetDeepening();
          performSearch($inputField.val());
        } else {
          if (!currentDeepening) {
            reset();
          }
        }
      } else {
        var items = "";
        var anzahl = 0;
        var eingabe = $inputField.val().toLowerCase();
        if (eingabe.length > 0) {
          if (eingabe.length > 2) {
            for (var i = 0; i < globalKeywords.length; i++) {
              var wort = globalKeywords[i].toLowerCase();
              if (wort.indexOf(eingabe) !== -1) {
                var start = wort.indexOf(eingabe),
                  end = start + eingabe.length - 1,
                  display = "";
                for (
                  var letterIndex = 0;
                  letterIndex < wort.length;
                  letterIndex++
                ) {
                  if (letterIndex === start) {
                    display += "<b>";
                  }
                  display += wort[letterIndex];
                  if (letterIndex === end) {
                    display += "</b>";
                  }
                }
                items +=
                  '<li><a href="javascript:void(0)" data-keywords="' +
                  globalKeywords[i] +
                  '">' +
                  display +
                  "</a></li>";
                anzahl++;
              }
            }
            if (anzahl > 0) {
              $suggestions.html(items).show();
              // Stichwort auswählen > Treffer anzeigen, andere ausblenden
              $suggestions.find("a").on("click", function (event) {
                //resetDeepening();
                performSearch($(this).data("keywords"));
              });
            } else {
              $suggestions
                .html(
                  '<li class="no-entries suggestions">Leider keine Treffer</li>'
                )
                .show();
            }
          }
        } else {
          $suggestions.hide();
          if (!currentDeepening) {
            reset();
          }
        }
      }
      openPanels();
    };

    /**
     * Hide suggestions and perform the search
     * Show parents if either:
     * - A parent title contains the searchword
     * - A parent's keyword matches the searchword
     * - A Child matches the searchword by title or keywords
     *
     * Show child if either:
     * - A child title contains the searchword
     * - A child's keyword matches the searchword
     */
    var performSearch = function (searchWord, isDeepeningSeach) {
      if (isDeepeningSeach) {
        if (!currentDeepening) {
          reset();
        } else {
          // console.log(currentTabId);
          $("#" + currentTabId + " .c-parent > li > span").each(function () {
            var $parentLink = $(this),
              $parent = $parentLink.parents("ul.c-parent").parent(),
              showParent = false;

            var thisDeepening = "";
            if ($parentLink.data("deepening")) {
              thisDeepening = String($parentLink.data("deepening"));
            }
            if (
              thisDeepening &&
              thisDeepening.indexOf(currentDeepening) !== -1
            ) {
              showParent = true;
            }

            if (showParent) {
              $parent.show();
            } else {
              $parent.hide();
            }
          });
        }
      } else {
        $inputField.val(searchWord);
        $suggestions.hide();

        if (searchWord !== undefined) {
          searchWord = searchWord.toLowerCase();
        } else {
          searchWord = "";
        }

        $("#" + currentTabId + " .c-parent > li > span").each(function () {
          var $parentLink = $(this),
            $parent = $parentLink.parents("ul.c-parent").parent(),
            showParent = false,
            currentLinkTitle = $parentLink.text(),
            currentKeywords = $parentLink.data("keywords");

          // console.log( 'searchWord', searchWord );
          // console.log( $parentLink );
          // console.log( $parent );
          // console.log( 'currentLinkTitle', currentLinkTitle );
          // console.log( 'currentKeywords', currentKeywords );

          if (currentLinkTitle) {
            currentLinkTitle = currentLinkTitle.trim().toLowerCase();
            if (
              currentLinkTitle &&
              currentLinkTitle.indexOf(searchWord) !== -1
            ) {
              showParent = true;
            }
          }
          if (currentKeywords) {
            currentKeywords = currentKeywords.trim();
            // No need to check keywords if parent is already supposed to be shown
            if (!showParent && currentKeywords) {
              currentKeywords = currentKeywords.split(",");
              if (currentKeywords) {
                // Trim all array values as well
                $.each(currentKeywords, function (index, keyword) {
                  // currentKeywords[index] = keyword.toLowerCase().trim();
                  if (
                    currentChildKeywords[index]
                      .toLowerCase()
                      .trim()
                      .indexOf(searchWord.toLowerCase().trim()) !== -1
                  ) {
                    showChild = true;
                  }
                });
                if (currentKeywords.indexOf(searchWord) !== -1) {
                  showParent = true;
                }
              }
            }
          }
          if (showParent) {
            $parent.show();
          } else {
            $parent.find(".c-childs > li").each(function () {
              var currentChildTitle = $(this).text();
              var showChild = false;
              if (currentChildTitle) {
                currentChildTitle = currentChildTitle.trim().toLowerCase();
                // alert( 'currentChildTitle: ' + currentChildTitle );
                if (
                  currentChildTitle &&
                  currentChildTitle.indexOf(searchWord) !== -1
                ) {
                  showChild = true;
                } else {
                  var currentChildKeywords = $(this).data("keywords");
                  if (currentChildKeywords) {
                    currentChildKeywords = currentChildKeywords
                      .trim()
                      .split(",");
                    if (currentChildKeywords) {
                      /* Trim all array values as well */
                      $.each(currentChildKeywords, function (index, keyword) {
                        // currentChildKeywords[index] = keyword.toLowerCase().trim();
                        if (
                          currentChildKeywords[index]
                            .toLowerCase()
                            .trim()
                            .indexOf(searchWord.toLowerCase().trim()) !== -1
                        ) {
                          showChild = true;
                        }
                      });
                    }
                  }
                }
              }
              if (showChild) {
                $(this).parent().show();
                showParent = true;
                // $('.c-childs').parent().addClass('active');
                // $('.c-childs').css('display', 'block');
              } else {
                $(this).parent().hide();
              }
            });

            if (showParent) {
              $parent.show();
            } else {
              $parent.hide();
            }
          }
        });
      }

      $(".no-result").remove();
      if ($("#" + currentTabId + " .list-with-arrow:visible").length < 1) {
        $("#" + currentTabId + "").append(
          "<div class='no-result'><p>Leider konnten keine Ergebnisse gefunden werden</p></div>"
        );
      }
      openPanels();
    };

    var citySelect = function (city) {
      $(".c-childs li").show();
      $(".c-childs").parent().parent().parent().parent().show();

      if (city !== "") {
        $(".c-childs li").show();
        //$('.c-childs li').not('.' + city).hide();
      }

      $(".c-childs").each(function () {
        if ($(this).children(":visible").length === 0) {
          $(this).parent().parent().parent().parent().hide();
        }
      });
      openPanels();
    };

    /* Reset and show all elements either by a given tabId or by the current tabId */
    var reset = function (tabId) {
      if (tabId) {
        $(
          "#" +
            tabId +
            " .c-parent > li > span, #" +
            tabId +
            " .c-childs > li > span > a"
        ).show();
      } else {
        $(
          "#" +
            currentTabId +
            " .list-with-arrow, #" +
            currentTabId +
            " .c-childs > li"
        ).show();
        // $('.c-childs').parent().removeClass('active');
        // $('.c-childs').css('display', 'none');
      }
      $inputField.val("");
      $suggestions.hide();
      $(".no-result").remove();
      openPanels();
    };

    var resetDeepening = function () {
      currentDeepening = 0;
      $(".page-clinics-and-centers .nice-select span.current").html(
        "Alle Standorte"
      );
      openPanels();
    };
  });
})(jQuery);

/**
 * URL Parameter auslesen
 * var allVars = $.getUrlVars();
 * var someVar = $.getUrlVar('someVar');
 */
$.extend({
  getUrlVars: function () {
    var vars = [],
      hash;
    var location = decodeURIComponent(window.location.href);
    var hashes = location
      .slice(window.location.href.indexOf("?") + 1)
      .split("&");

    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split("=");
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  },
  getUrlVar: function (name) {
    return $.getUrlVars()[name];
  },
});

/**
 * Check if needle is in haystack but do not respect case-sensitivity
 * @param needle
 * @param haystack
 */
function inArray(needle, haystack) {
  var isInArray = false;
  needle = needle.toLowerCase();
  $.each(haystack, function (index, value) {
    if (value.toLowerCase() === needle) {
      isInArray = true;
      return true;
    }
  });
  return isInArray;
}

/* Umlaute richtig sortieren */
function compareStrings(a, b) {
  a = a.toLowerCase();
  a = a.replace("ä", "ae");
  a = a.replace("ö", "oe");
  a = a.replace("ü", "ue");
  a = a.replace("ß", "ss");

  b = b.toLowerCase();
  b = b.replace("ä", "ae");
  b = b.replace("ö", "oe");
  b = b.replace("ü", "ue");
  b = b.replace("ß", "ss");

  return a == b ? 0 : a > b ? 1 : -1;
}
